import React from 'react';
import img3 from '../../../src/assets/step1.webp'
import img4 from '../../../src/assets/step2.webp'
import img5 from '../../../src/assets/step3.webp'
import img6 from '../../../src/assets/connector-line.svg'
import img7 from '../../../src/assets/connector-line-mobile.webp'
import img8 from '../../../src/assets/connector-line2.svg'
import img9 from '../../../src/assets/connector-line-mobile.webp'
import img10 from '../../../src/assets/arrow-new-step.webp'
import img11 from '../../../src/assets/arrow-new-step1.webp'

const StepPart = () => {
    return (
        <>
            <div className="brainer-section">
                <div className="container">
                    <div className="row align-items-center step-width">
                        <div className="col-12 col-lg-6  col-md-7 order-2 order-md-1 text-center text-md-start col-xxl-6" >
                            <img src={img3} alt="Step 1" className="img-fluid img-step" loading="lazy"/>
                        </div>
                        <div className="col-md-5 col-lg-6 col-12 order-1 order-md-2 col-xxl-6 margin-order">
                            <div className="ps-md-4 ps-lg-1 mobile-center-badge">
                                <div className="step-badge">Step 1</div>
                                <h2 className="step-head">Dip</h2>
                            </div>
                        </div>
                        <div className="col-12 d-flex justify-content-center order-3 text-center">
                            <img src={img11} alt="Connector Line" className="ps-4 width-arrow img-fluid d-md-block d-none" loading="lazy" />
                            <img src={img7} alt="Connector Line Mobile" className="img-fluid d-md-none  arrow-mobile-height" loading="lazy" />
                        </div>
                    </div>
                    <div className="row align-items-center step-width step-width-new">
                        <div className="col-md-5 col-lg-0 ">
                            <div className="mobile-center-badge  mobile-center-badge-desk step-none">
                                <div className="step-badge">Step 2</div>
                                <h2 className="step-head">Snap</h2>
                            </div>
                        </div>
                        <div className="col-md-7 col-lg-12 text-md-end text-center ">
                           <div className='d-flex align-items-center justify-content-lg-end justify-content-center  gap45'>
                           <img src={img4} alt="Step 2" className="img-fluid img-step" loading="lazy" />
                            <div className="mobile-center-badge desktop-step">
                                <div className="step-badge">Step 2</div>
                                <h2 className="step-head">Snap</h2>
                            </div>
                           </div>
                        </div>
                        <div className="col-12 d-flex justify-content-center text-center">
                            <img src={img10} alt="Connector Line 2" className="img-fluid d-md-block width-arrow d-none" loading="lazy" />
                            <img src={img9} alt="Connector Line Mobile 2" className="img-fluid d-md-none  arrow-mobile-height" loading="lazy" />
                        </div>
                    </div>
                    <div className="row align-items-center step-width">
                        <div className="col-12 col-lg-6 col-md-7 order-2 order-md-1 text-center text-md-start col-xxl-6">
                            <img src={img5} alt="Step 3" className="img-fluid img-step" loading="lazy" />
                        </div>
                        <div className="col-md-5 col-lg-6 order-1 order-md-2 col-xxl-6 margin-order">
                            <div className="ps-md-4 ps-lg-1 mobile-center-badge">
                                <div className="step-badge">Step 3</div>
                                <h2 className="step-head">Swim</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <button className="btn btn-guide landing-slider-button">Grab My Guide</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StepPart;
